import * as React from "react";

// style, design

import CancelServiceContractForm from "../../components/Forms/ServiceContract/CancelForm/FlowForm";

export default function ServiceCancel() {
  return <CancelServiceContractForm />;
}
